import { AppUser } from 'Src/views/App/App';
import axios from 'axios';
import { ALL_LIMIT } from 'Src/consts/table';

export function getPreRegistrationsUsers(user: AppUser, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios.get(`${window.apiBase}/admin/users/preRegistered`, config).then(response => {
    return response.data;
  });
}

export function getAllPreRegistrationsUsers(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios.get(`${window.apiBase}/admin/users/preRegistered`, config).then(response => {
    return response.data;
  });
}

export function getPreRegistrationsUsersCount(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios.get(`${window.apiBase}/admin/users/preRegistered/count`, config).then(response => {
    return response.data;
  });
}

export function addUser(user: AppUser, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios.post(`${window.apiBase}/admin/users`, data, config).then(response => {
    return response.data;
  });
}

export function deletePreRegistrationsUser(user: AppUser, preRegisteredUserIds) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .post(`${window.apiBase}/admin/users/preRegistered/remove`, preRegisteredUserIds, config)
    .then(response => {
      return response.data;
    });
}

export function resetLoginCountPreRegistrationsUser(user: AppUser) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios.post(`${window.apiBase}/admin/users/preRegistered/resetLoginCount`, {}, config).then(response => {
    return response.data;
  });
}

export function getDirectAccessCode(user: AppUser, username: string, password: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .post(
      `${window.apiBase}/admin/users/preRegistered/directAccessCode`,
      {
        username,
        password,
      },
      config
    )
    .then(response => {
      return response.data;
    });
}
